// extracted by mini-css-extract-plugin
module.exports = {"HeroColumn":"HeroColumn_HeroColumn__YiYcz","paragraph":"HeroColumn_paragraph__dVhMe"};